export default "__VITE_ASSET__bfe1bf8e__"